import {request} from './repository';

const url = 'search';

const siteSearchRepository = {
    search(search) {
        return request.get(url, {
            search: search
        })
    }
}

export default siteSearchRepository